import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Title from '../Title';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import Input from '@ertelecom/ui-react/components/input';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import { sendRequestByConnection, parseRequestByConnection } from '~/src/api/service-request/request-by-connection';

const ConnectFormSection = styled.div`
    width: 100%;
    padding: 95px 219px 105px;
    text-align: left;

    @media only screen and (max-width: 1919px) {
        padding: 95px 190px 53px;
    }

    @media only screen and (max-width: 1365px) {
        padding: 90px 50px 57px;
    } 

    @media only screen and (max-width: 1023px) {
        padding: 77px 50px 93px;
    }

    @media only screen and (max-width: 767px) {
        padding: 59px 16px 25px;
    }
`;

const ConnectForm = styled.div`
    margin-top: 31px;
    display: flex;
    flex-flow: row wrap;
    width: 100%;

    @media only screen and (max-width: 1919px) {
        margin-top: 33px;
    }
`;

const ConnectFormInputsGroup = styled.div`
    width: 100%;
    display: flex;
    flex-flow: row;

    @media only screen and (max-width: 767px) {
        flex-flow: row wrap;
    }
`;
const ConnectFormInput = styled(Input)`
    width: 412px;
    margin-right: 27px;
    margin-bottom: 0;

    @media only screen and (max-width: 1919px) {
        margin-right: 19px;
    }

    @media only screen and (max-width: 1365px) {
        margin-right: 12px;
    }

    @media only screen and (max-width: 767px) {
        width: 100%;
        margin-right: 0;
        margin-bottom: 19px;
    }
`;

const ConnectFormInfo = styled.div`
    width: 100%;
    display: flex;
    margin-top: 41px;
    align-items: center;

    @media only screen and (max-width: 767px) {
        margin-top: 0;
    }
`;

const ConnectFormButton = styled(StyledButton)`
    width: 190px;
    margin-right: 12px;

    @media only screen and (max-width: 767px) {
        width: 100%;
        margin-bottom: 19px;
        margin-right: 0;
    }
`;

const ConnectFormText = styled.p`
    width: 248px;
    font-size: 14px;
    line-height: 18px;
    font-family: 'robotoLight', sans-serif;
    color: ${ COLORS.darkGrey };

    a {
        color: ${ COLORS.darkGrey };
        border-bottom: 1px solid ${ COLORS.darkGrey };
    }
`;

const ConnectFormResponse = styled.p`
    color: ${ COLORS.lightGreen };
    font: 300 17px/24px 'robotoLight', sans-serif;
    margin-top: 10px;

    @media(max-width: 768px) {
        text-align: center;
    }
`;

const ConnectFormError = styled(ConnectFormResponse)`
    color: ${ COLORS.red };
`;

const PRODUCT_ID = '31';

class ConnectSection extends React.Component {
    state = {
        name: '',
        phone: '',
        status: 'hidden',
        message: null,
        isSending: true,
    };

    nameInput = React.createRef();
    phoneInput = React.createRef();

    static propTypes = {
        title: PropTypes.string,
    };

    onChangeValue = (nameValue, value) => {
        this.setState({
            [nameValue]: value,
        });

        const validName = this.nameInput.current.state.hasError;
        const validPhone = this.phoneInput.current.state.hasError;

        if (!validName && !validPhone) {
            this.setState({
                isSending: false,
            });
        } else {
            this.setState({
                isSending: true,
            });
        }
    };

    submitHandler = e => {
        e.preventDefault();
        const validName = this.nameInput.current.state.hasError;
        const validPhone = this.phoneInput.current.state.hasError;

        window.dataLayer = window.dataLayer || [];
        dataLayerPush({ event: 'UAevent', category: 'Ecommerce', action: 'trackTrans', label: '/request' });

        if (!validName && !validPhone) {
            const { name, phone }  = this.state;
            const { city } = this.props;
            const domain = city.domain;

            const dataParams = {};
            dataParams['domain'] = domain;
            dataParams['fio'] = name;
            dataParams['phone'] = phone;
            dataParams['petition'] = 'request';
            dataParams['product_id'] = PRODUCT_ID;

            sendRequestByConnection(domain, dataParams).then(res => {
                const { message, ok } = parseRequestByConnection(res);

                this.setState({
                    message,
                    status: ok,
                    name: '',
                    phone: '',
                });

                this.nameInput.current.refs.input.value = '';
                this.phoneInput.current.refs.input.value = '';

                this.nameInput.current.resetStateWithUpdates();
                this.phoneInput.current.resetStateWithUpdates();

                this.nameInput.current.state.hasError = true;
                this.phoneInput.current.state.hasError = true;

                this.setState({
                    isSending: true,
                });

            }).catch(() => {
                this.setState({
                    message: 'Не удалось отправить заявку. Пожалуйста, попробуйте еще раз.',
                    status: false,
                    isSending: true,
                });

                dataLayerPush({ event: 'UAevent', category: 'application_form', action: 'no', label: 'Произошла ошибка 100' });
            });
        } else {
            this.nameInput.current.state.hasError = true;
            this.phoneInput.current.state.hasError = true;

            this.setState({
                isSending: true,
            });

            return false;
        }
    }

    showMistakeOnInput = (refInput, boolean) => {
        if (refInput.current.state.hasError) {
            refInput.current.setShowError(boolean);
            refInput.current.setTouched(boolean);
            refInput.current.setHasError(boolean);
        }
    }

    componentDidMount() {
        this.nameInput.current.setHasError(true);
    }

    render() {
        const { title, className } = this.props;
        const { status, message, isSending } = this.state;

        const MessageText = (status !== 'hidden' && status)
        ? <ConnectFormResponse>{message}</ConnectFormResponse>
        : <ConnectFormError>{message}</ConnectFormError>;

        return (
        <ConnectFormSection className={className} id='formCallBack'>
            <Title as='h2' title={title}></Title>
            <ConnectForm>
            <ConnectFormInputsGroup>
                <ConnectFormInput
                    type='name'
                    name='Имя'
                    ref={this.nameInput}
                    placeholder='Ваше имя'
                    errorMessage='Должны быть только буквы'
                    onChange={(event) => this.onChangeValue('name', event)}
                    required
                />
                <ConnectFormInput
                    type='phone'
                    name='Телефон'
                    ref={this.phoneInput}
                    placeholder='Телефон'
                    errorMessage='Заполните телефон'
                    onChange={(event) => this.onChangeValue('phone', event)}
                    required
                />
            </ConnectFormInputsGroup>
            <ConnectFormInfo>
                <ConnectFormButton onClick={(event) => this.submitHandler(event)} disabled={ isSending }>Отправить заявку</ConnectFormButton>
                <ConnectFormText>Нажимая на кнопку, вы соглашаетесь на обработку <a href='https://dom.ru/policy.pdf' target='_blank' rel='noopener noreferrer'>персональных данных</a></ConnectFormText>
            </ConnectFormInfo>
            {status !== 'hidden' && MessageText}
            </ConnectForm>
        </ConnectFormSection>
        );
    }
}

export default ConnectSection;
